<div class="grid-container">
  <div class="content-with-elevation content">
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <common-alerts [errorMessage]="errorMessage"></common-alerts>
      <div class="grid-x">
        <div class="cell large-6 medium-12 small-12 content-with-elevation">
          <label>Two-Factor Authentication Required:
            <input formControlName="code" type="text"
                   class="input-group-custom" required>
          </label>
          <div class="grid-x align-end">
            <div class="save-cancel-button-group">
              <button class="iana-button" type="submit"
                      [disabled]="!form.valid">Proceed
              </button>
            </div>
          </div>
        </div>
        <div class="cell large-6 medium-12 small-12">
          <p>Open your two-factor authenticator (TOTP) app and enter your authentication code</p>
          <p><b>Unable to access your device or authenticator app?</b><br>You can also enter one of the recovery codes generated when you set up multi-factor authentication.</p>
          <p>For additional assistance, please contact <a href="mailto:root-mgmt@iana.org">root-mgmt&#64;iana.org</a></p>

        </div>
      </div>
    </form>
  </div>
</div>
